const en = {
pleaseEnterUsername: "Please enter a username",
cannotFriendYourself: "You can't send a friend request to yourself.",
friendRequestSent: "Friend request sent!",
failedToSendRequest: "Failed to send request",
linkCopied: "Link copied to clipboard!",
backToInvites: "Back to Invites",
sendFriendRequestByUsername: "Send Friend Request by Username",
enterUsername: "Enter username",
send: "Send",
yourInviteQrCode: "Your Invite QR Code",
inviteLink: "Invite Link",
scanQrOrUseLink: "Scan this QR code or go to this link to send a friend request",
copyInviteLink: "Copy invite link",
goToItem: "Go to item",
verificationEmailSent: "Verification email sent! Check your inbox.",
verificationEmailFailed: "Failed to send verification email. Please try again.",
verifyYourEmail: "Verify Your Email",
verifyEmailInstructions: "Please verify your email address to access your account. Check your inbox for a verification link.",
sending: "Sending...",
resendVerificationEmail: "Resend Verification Email",
login: "Login",
register: "Register",
home: "Home",
calendar: "Calendar",
friends: "Friends",
profile: "Profile",
logout: "Logout",
loading: "Loading...",
language: "Language",
calendarSelectPlaceSuggestion: "Please select a place from the suggestions so coordinates are attached.",
calendarSelectDateAndTime: "Please select date and time.",
calendarPositiveDuration: "Please provide a positive duration.",
calendarFutureDateRequired: "Event date and time must be in the future.",
calendarCreateEventFailed: "Failed to create event. Please try again.",
cancel: "Cancel",
createNewEvent: "Create New Event",
week: "Week",
month: "Month",
eventTitle: "Title",
date: "Date",
time: "Time",
duration: "Duration",
endsAt: "Ends at",
place: "Place",
searchForPlace: "Search for a place",
placeSearchTip: "Tip: start typing and select a result to attach coordinates.",
description: "Description",
createEvent: "Create Event",
today: "Today",
previousMonth: "Previous month",
nextMonth: "Next month",
previous: "Prev",
next: "Next",
mondayShort: "Mon",
tuesdayShort: "Tue",
wednesdayShort: "Wed",
thursdayShort: "Thu",
fridayShort: "Fri",
saturdayShort: "Sat",
sundayShort: "Sun",
more: "more",
mustRespondWillBeforeReposting: 'You must respond "will" before reposting',
event: "Event",
backToCalendar: "Back to Calendar",
addToGoogleCalendar: "Add to Google Calendar",
when: "When",
where: "Where",
openLocationInGoogleMaps: "Open location in Google Maps",
hosts: "Hosts",
yourResponse: "Your Response",
currentResponse: "Current response",
response_will: "Will attend",
response_might: "Might attend",
response_wont: "Won't attend",
willRunIntoYou: "Will run into you",
mightDropBy: "Might drop by",
wontCome: "Won't come",
repostToMyFriends: "Repost to my friends",
responses: "Responses",
willAttend: "Will attend",
reposted: "Reposted",
mightAttend: "Might attend",
cancelEvent: "Cancel Event",
cancellationEmailNoticeBefore: "Respondents who said they would come",
cancellationEmailNoticeAfter: "will be emailed to notify them of the cancellation.",
optionalCancellationMessage: "Optional message to attendees (max 1000 characters)",
confirmCancelEvent: "Confirm Cancel Event",
clear: "Clear",
confirmCancellation: "Confirm cancellation",
confirmCancellationMessage: "Are you sure you want to cancel this event? This will notify confirmed attendees and remove the event.",
eventCancelledNotified: "Event cancelled. Notified",
attendees: "attendees",
failedToCancelEvent: "Failed to cancel event",
back: "Back",
cancelled: "Cancelled",
ok: "OK",
forgotPassword: "Forgot Password",
email: "Email",
passwordResetLinkSent: "If an account exists, a reset link was sent.",
passwordResetRequestFailed: "Failed to request password reset.",
sendResetLink: "Send Reset Link",
addFriend: "Add Friend",
incomingRequests: "Incoming Requests",
accept: "Accept",
deny: "Deny",
myFriends: "My Friends",
noFriendsYet: "No friends yet. Start adding some!",
seeProfile: "See Profile",
noEventsToRespondTo: "No events to respond to",
allCaughtUp: "You're all caught up — check back later for new events from your friends.",
events: "Events",
unknown: "Unknown",
noDescriptionProvided: "No description provided.",
will: "Will",
maybe: "Maybe",
wont: "Won't",
userNotFound: "User not found",
friendRequestSentSuccessfully: "Friend request sent successfully!",
friendInvitation: "Friend Invitation",
sendFriendRequest: "Send Friend Request",
loginToSendFriendRequest: "Please log in to send a friend request",
chooseLanguage: "Choose Language",
invalidCredentials: "Invalid credentials. Please try again.",
username: "Username",
password: "Password",
forgotPasswordQuestion: "Forgot password?",
dontHaveAccount: "Don't have an account?",
registerHere: "Register here",
invalidProfilePhotoType: "Invalid file type. Please upload a JPEG, PNG, GIF, or WebP image.",
invalidFileExtension: "Invalid file extension",
allowedExtensions: "Allowed",
fileTooLarge: "File too large",
maximumFileSize: "Maximum",
profilePhotoRemoved: "Profile photo removed.",
failedToRemoveProfilePhoto: "Failed to remove profile photo",
profileUpdatedSuccessfully: "Profile updated successfully!",
failedToUpdateProfile: "Failed to update profile",
privateEmailExplanation: "Only you can see your email to avoid unsolicited messages off-platform",
yourEmailIsPrivate: "Your email is private.",
profilePhoto: "Profile Photo",
removePhoto: "Remove Photo",
firstName: "First Name",
lastName: "Last Name",
tellPeopleAboutYourself: "Tell people about yourself",
whereToContactMe: "Where To Contact Me",
contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
save: "Save",
notSet: "Not set",
editProfile: "Edit Profile",
imageToCrop: "Image to crop",
zoom: "Zoom",
usePhoto: "Use Photo",
name: "Name",
whereToContact: "Where To Contact",
removeFriendship: "Remove Friendship",
confirmRemoveFriend: "Confirm remove friend",
confirmRemoveFriendBefore: "Are you sure you want to remove",
confirmRemoveFriendAfter: "as a friend? This will remove them from your friends list.",
friendRemoved: "Friend removed.",
failedToRemoveFriend: "Failed to remove friend.",
confirmRemove: "Confirm Remove",
error: "Error",
removed: "Removed",
passwordsDoNotMatch: "Passwords do not match",
registrationFailed: "Registration failed. Please try again.",
confirmPassword: "Confirm Password",
alreadyHaveAccount: "Already have an account?",
loginHere: "Login here",
passwordResetSuccessfully: "Password reset successfully.",
failedToResetPassword: "Failed to reset password.",
resetPassword: "Reset Password",
newPassword: "New Password",
confirmNewPassword: "Confirm New Password",
setNewPassword: "Set New Password",
emailVerifiedSuccessfully: "Email verified successfully!",
emailVerificationFailed: "Verification failed. The link may be invalid or expired.",
verifying: "Verifying...",
verified: "Verified!",
redirectingToHome: "Redirecting you to home...",
verificationFailed: "Verification Failed",
goToHome: "Go to Home",
  about: "About",
  aboutConceptTitle: "Concept",
  aboutCreatorIntroduction: "Hey, I'm Crypt0, a rock climber and Run Into Me's creator.",
  aboutCreatorStory: "I created this website because I'm a social butterfly and, in between climbing two walls, can't help talking to other climbers. This led me to have a few too many climbers' phone numbers stored in my contacts, and using too much of my off-time scheduling climbing sessions with my new friends, like an overbooked Hollywood agent.",
  aboutPlanningProblem: "I got annoyed at having to plan these sessions and individually message my friends; I wished I could just let them all know simultaneously when and where I would be climbing without formally inviting them, so they could just drop by if they felt like RUN(NING) INTO ME.",
  aboutDeveloperSolution: "That's when I remembered I happened to be a dev and could just make a solution myself.",
  aboutWelcome: "So welcome to Run Into Me, a website to let your friends know when you are doing an activity that they can join in on, no pressure.",
  aboutCallToAction: "The next time you plan on doing an activity that you can do alone, but would be more fun together (cinema, running, climbing... taxes???), post it here for your friends to see!",
  aboutTutorialTitle: "Tutorial",
  aboutCalendarCreateEvent: "The Calendar Screen is also where you create a new event.",
  aboutEventColorsIntroduction: "Event colors indicate your participation status:",
  aboutColorGold: "Gold",
  aboutColorGoldDescription: "You are hosting this event.",
  aboutColorGreen: "Green",
  aboutColorGreenDescription: "You are attending this event.",
  aboutColorOrange: "Orange",
  aboutColorOrangeDescription: "You responded \"maybe\".",
  aboutColorBlue: "Blue",
  aboutColorBlueDescription: "You have not responded yet.",
  aboutColorGray: "Gray",
  aboutColorGrayDescription: "You declined the invitation.",
  aboutCalendarEventDetails: "Click on an event for more information and to respond to it.",
  aboutFriendPageTitle: "Friend Page",
  aboutFriendPageDescription: "To add a friend, either enter their username or give them your invite link / QR code.",
  aboutHomePageTitle: "Home Page",
  aboutHomePageDescription: "Swipe through your friends' upcoming events on the Home Screen to let them know whether you are coming.",
  aboutRepostScreenTitle: "Repost Screen",
  aboutGoogleCalendarDescription: "To make sure you do not miss an event, use this button to add it to your Google Calendar.",
  aboutRepostDescription: "Once you have responded that you will attend a friend's event, you can repost it to your friends. The invitation will then appear on the calendars of your friends who are not on the host's friend list.",
};

export default en;